import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';
import type { ApiResponse } from 'vopay';

const { api } = vopayApi;

export default function useBlockAccounts() {
  const source = axios.CancelToken.source();
  const [blockLoading, setBlockLoading] = useState(false);
  const [unblockLoading, setUnblockLoading] = useState(false);
  const [blockAccountLoading, setBlockAccountLoading] = useState(false);
  const [unblockAccountLoading, setUnblockAccountLoading] = useState(false);

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  async function blockAccounts(): Promise<ApiResponse> {
    try {
      setBlockLoading(true);

      const res = await api.blockAccounts(undefined, source);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (err) {
      console.error('Block accounts failed:', err);
      throw err;
    } finally {
      setBlockLoading(false);
    }
  }

  async function unblockAccounts(): Promise<ApiResponse> {
    try {
      setUnblockLoading(true);

      const res = await api.unblockAccounts(undefined, source);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (err) {
      console.error('Unblock accounts failed:', err);
      throw err;
    } finally {
      setUnblockLoading(false);
    }
  }

  async function blockAccount(vopayAccountID: string): Promise<ApiResponse> {
    try {
      setBlockAccountLoading(true);

      const res = await api.blockAccounts({ VopayAccountID: vopayAccountID }, source);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (err) {
      console.error('Block account failed:', err);
      throw err;
    } finally {
      setBlockAccountLoading(false);
    }
  }

  async function unblockAccount(vopayAccountID: string): Promise<ApiResponse> {
    try {
      setUnblockAccountLoading(true);

      const res = await api.unblockAccounts({ VopayAccountID: vopayAccountID }, source);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (err) {
      console.error('Unblock account failed:', err);
      throw err;
    } finally {
      setUnblockAccountLoading(false);
    }
  }

  return {
    blockLoading,
    unblockLoading,
    blockAccountLoading,
    unblockAccountLoading,
    blockAccounts,
    unblockAccounts,
    blockAccount,
    unblockAccount,
  };
}
